import lazyLoading from './components/lazyLoading';

const $body = $('body');

function enter(page, num) {
	return new Promise((resolve) => {
		let $page = $(`.${page}`);

		lazyLoading.init();

		if (num) {
			$page = $(`[data-page="${page}-${num}"]`);
		}

		$body.removeClass('is-hidden');
		$page.removeClass('is-hidden');

		if (page === 'article') {
			$('.footer__text a').addClass('is-article');
		} else if (page === 'details') {
			// do something
		} else if (page === 'test') {
			// do something
		} else {
			$('.footer__text a').removeClass('is-article');
		}

		$('.article__sidebar-inner:visible').stick_in_parent({
			offset_top: 100,
		});

		gsap.from($body, 0.3, {
			onComplete: resolve,
			opacity: 0,
			clearProps: 'all',
		});
	});
}

function leave(page, num) {
	return new Promise((resolve) => {
		let $page = $(`.${page}`);

		if (num) {
			$page = $(`[data-page="${page}-${num}"]`);
		}

		gsap.to($body, 0.3, {
			onComplete() {
				$body.addClass('is-hidden');
				$page.addClass('is-hidden');

				resolve();
			},
			opacity: 0,
			clearProps: 'all',
		});
	});
}

export default {
	enter,
	leave,
};
